import { render } from "./ServiceView.vue?vue&type=template&id=d3f40a72&scoped=true"
import script from "./ServiceView.vue?vue&type=script&lang=js"
export * from "./ServiceView.vue?vue&type=script&lang=js"

import "./ServiceView.vue?vue&type=style&index=0&id=d3f40a72&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3f40a72"]])

export default __exports__